export enum AltitudeMode {
  InheritFromParent = -1,
  RelativeToGround,
  Absolute,
  ClampToGround,
}
